'use client';

import BalancedContentSection from '@/components/sections/BalancedContentSection/BalancedContentSection';
import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';
import { OurMissionSection } from '@/features/aboutUs/hooks/types';

const OurMission = ({ data }: { data: OurMissionSection }) => {
  if (!data) return <p>About Us page not found</p>;

  const { heading, description, text, imageUrl } = data;

  return (
    <div className="pt-8 md:pt-10">
      <BalancedContentSection
        spacingClassName="md:py-10 py-8"
        data={{
          ...data,
          backgroundColor: 'bg-surface-light',
          textPosition: 'left',
        }}
        mediaContent={
          imageUrl ? (
            <div className="overflow-hidden rounded-lg">
              <R2Image
                path={data.imageUrl}
                width={604}
                alt={'our mission image'}
                height={411}
                className="h-102.75 w-full scale-[1.12] rounded-lg object-cover object-[center_35%]"
                sizes="(min-width: 611px) 611px, 100vw"
              />
            </div>
          ) : null
        }
        textContent={
          <div className="space-y-6">
            <RichText
              styles={
                heading?.styles || {
                  h2: 'text-h2 text-theme-primary mb-4 md:mb-5',
                }
              }
            >
              {heading?.content}
            </RichText>
            <RichText
              styles={
                description?.styles || {
                  p: 'text-body text-text-body-dark',
                }
              }
            >
              {description?.content}
            </RichText>
            <RichText
              styles={
                text?.styles || {
                  p: 'text-body font-bold text-text-body-dark',
                }
              }
            >
              {text?.content}
            </RichText>
          </div>
        }
      />
    </div>
  );
};

export default OurMission;
